export function convertToAIMessage(message) {
    // concat all the textual part into a single string as content. and tool invocations tool parts into a single object as content.
    const aiParts = message.parts.flatMap((part) => {
        if (part.type === 'text') {
            return [{
                    type: 'text',
                    text: part.text,
                }];
        }
        if (part.type === 'tool-invocation') {
            const toolCallId = Date.now().toString();
            return [
                {
                    type: 'tool-invocation',
                    toolInvocation: {
                        state: 'call',
                        toolName: part.toolInvocation.toolName,
                        toolCallId,
                        step: part.toolInvocation.step,
                        args: part.toolInvocation.args,
                    }
                },
                {
                    type: 'tool-invocation',
                    toolInvocation: {
                        state: 'result',
                        toolName: part.toolInvocation.toolName,
                        toolCallId,
                        result: part.toolInvocation.result,
                        step: part.toolInvocation.step,
                        args: part.toolInvocation.args,
                    }
                }
            ];
        }
        if (part.type === 'step-start') {
            return [{
                    type: 'step-start',
                }];
        }
        return [];
    });
    return {
        id: message.id,
        role: message.role,
        content: message.parts.map((part) => part.type === 'text' ? part.text : '').join(''),
        parts: aiParts,
        // @ts-expect-error
        context: message.context,
        idempotencyKey: message.idempotencyKey,
        createdAt: message.createdAt,
    };
}
//# sourceMappingURL=messageHelper.js.map